import {css} from '@emotion/react'
import {LoadingOutlined} from '@ant-design/icons'

export const ResponseBodyLoadingPlain = ({message, ...props}) => {
    return (
        <div
            {...props}
        >
            <LoadingOutlined /> {message.content}
        </div>
    )
}
